'use client'

import { useEffect } from 'react'
import { useRouterState } from '@tanstack/react-router'
import { isAnalyticsEnabled, trackPageView } from '@/lib/analytics'

export function AnalyticsProvider() {
  const pathname = useRouterState({
    select: (state) => state.location.pathname,
  })

  useEffect(() => {
    if (isAnalyticsEnabled()) {
      trackPageView(pathname)
    }
  }, [pathname])

  return null
}
